var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currentName)?_c(_vm.currentName,{tag:"component",staticClass:"v-icon",class:`--${_vm.currentName}`,attrs:{"size":_vm.size,"color":_vm.color}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }